import { useSelector } from 'react-redux';
import { DashboardTutor } from './dashboardTutor';
import { DashboardStudent } from './dashboardStudent';
import { ProfileRole } from '../../store/profile/profileSlice';

const Dashboard = () => {
	const { currentProfile } = useSelector((state) => state.profile);
	
	return (
		<>
			{(currentProfile?.role === ProfileRole.TUTOR && <DashboardTutor />)}
			{(currentProfile?.role === ProfileRole.STUDENT && <DashboardStudent />)}
		</>
	);
};

export { Dashboard };
